export default "__VITE_ASSET__DM5xRk1d__"